import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$org/documents')({
    component: Documents,
})

function Documents() {
    return <Outlet />
}
